export default function (value) {
  if (value === 0) return '€ 0,-'

  return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(value).replace('€', '€ ').replace(',00', ',-')
}
